export interface MediaFile {
    downloadURL: string;
    type: 'image' | 'video';
    primary?: boolean;
    path?: string;
}

export interface ProductVariant {
    id?: string;
    name?: string;
    price: number;
    cost: number;
}

export interface Customer {
    id: string;
    name: string | null;
    email: string;
    status: 'active' | 'completed';
    createdAt: any;
    updatedAt?: any;
    notes?: string;
}

export interface MediaItem {
    id: string;
    docPath?: string; // Full Firestore document path
    name?: string;
    description?: string;
    caption?: string;
    price?: { 
        value: string;
        cost?: string;
    };
    features?: string;
    createdAt: any;
    media: MediaFile[];
    url?: string;
    variants?: ProductVariant[];
    isPublished?: boolean;
    type?: 'Video' | 'Sidecar' | 'image';
    startAt?: number; // Video trim start time
    endAt?: number; // Video trim end time
    status?: string; // 'approved' | 'rejected' | undefined
    mediaDownloaded?: boolean; // Flag to indicate if media has been downloaded and stored
    childPosts?: Array<{
        id: string;
        displayUrl: string;
        videoUrl?: string;
        type: string;
        url?: string;
    }>;
}

export const getThumbnail = (item: MediaItem, preview: 'list' | 'grid' = 'grid'): string => {
    // If no media array, use the direct url
    if (!item.media || item.media.length === 0) {
        return item.url || '';
    }

    let raw: string;
    const primary = item.media.find((mediaItem) => mediaItem.primary);

    if (primary) {
        raw = primary.downloadURL;
    } else {
        raw = item.media.filter(mediaItem => mediaItem.type !== 'video')[0]?.downloadURL ?? '';
    }

    if (!raw) return item.url || '';

    // If URL is from Instagram or external source, return as-is (for IGPosts)
    if (raw.includes('instagram') || raw.includes('cdninstagram') || !raw.includes('sellox')) {
        return raw;
    }

    try {
        let path = new URL(raw).pathname;
        path = path.replace(/.*.com/, '');
        path = path.substring(3);

        if (preview === 'list') {
            return (
                'https://cdn.sellox.app/preview/' +
                path +
                '?auto=compress&width=200&height=250&fit=crop&w=365&h=512'
            );
        }

        return (
            'https://cdn.sellox.app/preview/' +
            path +
            '?auto=compress&width=200&height=250&fit=crop&w=365&h=512'
        );
    } catch (error) {
        console.error('Error generating thumbnail:', error);
        return raw; // Return raw URL on error
    }
};
